export const environment = {
  production: true,
  version: '1.0.1',
  userId: '15',
  API_URL : 'https://back.scanini.tn/api'
};
